// test2729
(2729 && 0);
